'use strict';

document.addEventListener('DOMContentLoaded', function() {

  /**
   * パラメータ取得関数
   * URLのクエリ文字列から指定されたパラメータ名に対応する値を取得します。
   * @param {string} name 取得したいパラメータ名
   * @param {string} url 別ページのURLを使用したい場合
   * @returns {string|null} パラメータの値、またはパラメータが存在しない場合はnull
   */
  function getParam(name, url = window.location.search) {
    const params = new URLSearchParams(url);
    const value = params.get(name);
    return value ? sanitizeUrl(value) : null;
  }


  /**
   * エスケープ関数
   * HTMLエスケープ処理を行うための関数です。
   * @param {string} input エスケープしたい文字列
   * @returns {string} エスケープ処理後の文字列
   */
  function sanitizeUrl(input) {
    if (typeof input !== 'string') {
      throw new TypeError('Expected a string');
    }
    return input.replace(/[&'"<>]/g, function(match) {
      return {
        '&': '&amp;',
        "'": '&#x27;',
        '"': '&quot;',
        '<': '&lt;',
        '>': '&gt;',
      }[match];
    });
  }


  /**
   * 完成スクロール Lenis
   */
  let lenis;

  function initializeLenis() {
    if (window.innerWidth >= 781) {
      if (!lenis) {
        lenis = new Lenis();

        function raf(time) {
          if (lenis) {
            lenis.raf(time);
          }
          requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
      }
    } else {
      if (lenis) {
        lenis.destroy(); // 必要に応じてクリーンアップ
        lenis = null;
      }
    }
  }

  if ( !document.querySelector('.notLenis') ) {
    // 初期化時に実行
    initializeLenis();

    // リサイズ時にもチェック
    window.addEventListener('resize', initializeLenis);

  }



  // スクロールバーが出ている場合は、Lenisの影響を受けないようにしてスクロール可能にする
  const LenisNavElement = document.querySelector('.l-nav');
  LenisNavElement.addEventListener('wheel', function (event) {
    if (LenisNavElement.scrollHeight > LenisNavElement.clientHeight) {
      event.stopPropagation();
    }
  });

  if ( document.querySelector('.m-scrollX') ) {
    const LenisMScrollElement = document.querySelector('.m-scrollX');
    LenisMScrollElement.addEventListener('wheel', function (event) {
      if (LenisMScrollElement.scrollHeight > LenisMScrollElement.clientHeight) {
        event.stopPropagation();
      }
    });
  }


  // ヘッダーの追従処理
  function headerPositionControll() {
    // .index-aboutの位置を取得
    const headerWrap = document.querySelector(".l-header");

    // .index-aboutの上辺がデバイスの上辺に来たら
    if (indexAbout.getBoundingClientRect().top <= 0) {
        headerWrap.classList.add('is-show');
    } else {
        // それ以外の場合はpositionを元に戻す
        headerWrap.classList.remove('is-show');
    }
  }

  const indexAbout = document.querySelector(".index-about");
  if ( indexAbout ) {
    headerPositionControll();
    window.addEventListener("scroll", function () {
      headerPositionControll();
    });
  }


  $('.l-header a[href*="#"]').on('click', function() {
    if ( $('.l-navTrigger').css('display') !== 'none' ) {
      $('.l-navTriggerBg').fadeOut(200);
      $('.l-navTrigger').removeClass('is-open');
      $('.l-header').fadeOut();
    }
  })



  /**
   * アンカースクロール
   * @variable headerElement 固定ヘッダーセレクタ
   * @variable headerElement スクロール速度
   */

  let scroll = new SmoothScroll('a[href*="#"]', {
    speedAsDuration: true,
    speed: 1500,
    easing: 'easeInOutQuint'
  });

  // ページ表示時のアンカー位置にヘッダーの高さを考慮する

  // ハッシュ値があればロード時に高さを考慮した位置へスクロール位置を差し替え
  if ( window.location.hash !== '' ) {
    window.addEventListener('load', function() {
      const target = document.querySelector(window.location.hash);
      if ( target !== null ) {
        const position = target.offsetTop;
        document.documentElement.scrollTop = position;
      }
    });
  }


  /**
   * TOP：半導体ソリューション画像切替＆アコーディオン
   */
  $('.index-solution_nav_info_head').on('click', function() {
    let index = $('.index-solution_nav_info_head').index(this);
    if ($('.index-solution_nav_image_item').eq(index).hasClass('is-current')) return;

    $('.index-solution_nav_image_item').removeClass('is-current').eq(index).addClass('is-current');
    $('.index-solution_nav_info_head').removeClass('is-current').eq(index).addClass('is-current')
    $(this).next('.index-solution_nav_info_body').slideToggle(200, 'swing');
    $('.index-solution_nav_info_body').not($(this).next()).slideUp();
  });


  $('.l-navTrigger').on('click', function() {
    $(this).toggleClass('is-open');
    $('.l-navTriggerBg').fadeToggle(200);
    $('.l-header').fadeToggle();
  });


  /**
   * フッター：Contactのアニメーション
   */
  $('.l-footer_contact_btn_item').hover(
    function () {
      // ホバーした要素のz-indexを2に
      $(this).css('z-index', 2);
      // ホバーしていない他の要素のz-indexを1に
      $('.l-footer_contact_btn_item').not(this).css('z-index', 1);
    }
  );
  $('.l-footer_contact_btn_item').hover(
    function () {
      // ホバー時に画像を拡大
      $('.l-footer_contact_image img').addClass('scale-up');
    },
    function () {
      // ホバーが外れたら画像を元のサイズに戻す
      $('.l-footer_contact_image img').removeClass('scale-up');
    }
  );

  /**
   * アクセシビリティを考慮したスライダー
   * https://ja.splidejs.com/
   */
  /*
  <div class="splide js-slider" aria-label="screen-read-name">
    <div class="splide__track">
      <ul class="splide__list">
        <li class="splide__slide"></li>
      </ul>
    </div>
    <div class="splide__arrows">
      <button class="splide__arrow splide__arrow--prev">Prev</button>
      <ul class="splide__pagination"></ul>
      <button class="splide__arrow splide__arrow--next">Next</button>
    </div>
  </div>
  */


  if ( document.querySelector('.index-mv_keyword_slider') !== null ) {
    let indexMvKeywordSlider = new Splide('.index-mv_keyword_slider', {
      perPage       : 3,      // 1ページの表示数
      perMove       : 1,      // 1度にスライドを何枚移動するか
      type          : 'loop', // ループする場合
      pauseOnHover  : false,  // マウスホバー時に自動再生をストップさせない
      resetProgress : false,  // 自動再生ストップ時、経過時間を破棄せず続行する
      updateOnMove  : true,   // is-activeクラスを移動前に更新する
      gap           : '12px', // スライド間の余白（cssと同様）
      padding       : '50px', // 左右の見切れる幅（cssと同様）
      easing        : 'cubic-bezier(0.25, 1, 0.5, 1)', // 移動アニメーション
      autoWidth     : true,

      // 動き続けるスライダーを実装（拡張機能：splide-extension-auto-scroll.js）
      autoScroll: {
        speed: 0.5, // 負の値で流れる向きが右へ変更
        pauseOnHover: false,
        pauseOnFocus: false,
      },

      // メディアクエリ設定（初期：751px以上の場合、スライダーを動作させない）
      mediaQuery: 'max',
      breakpoints: {
        780: {
          autoScroll: {
            speed: 0.2, // 負の値で流れる向きが右へ変更
          },
        },
      },

    });


    // スライダーを実行
    // indexMvKeywordSlider.mount();
    indexMvKeywordSlider.mount(window.splide.Extensions);

  }

  // TOP：aboutエリアの上下スライダー
  if ( document.querySelector('.index-about_slider_rise') !== null ) {
    let indexAboutSliderRise = new Splide('.index-about_slider_rise', {
      perPage       : 3,      // 1ページの表示数
      perMove       : 1,      // 1度にスライドを何枚移動するか
      type          : 'loop', // ループする場合
      pauseOnHover  : false,  // マウスホバー時に自動再生をストップさせない
      resetProgress : false,  // 自動再生ストップ時、経過時間を破棄せず続行する
      updateOnMove  : true,   // is-activeクラスを移動前に更新する
      gap           : '30px', // スライド間の余白（cssと同様）
      easing        : 'cubic-bezier(0.25, 1, 0.5, 1)', // 移動アニメーション
      autoHeight    : true,
      direction     : 'ttb',
      heightRatio   : .5,
      drag          : false,

      // 動き続けるスライダーを実装（拡張機能：splide-extension-auto-scroll.js）
      autoScroll: {
        speed: .5, // 負の値で流れる向きが右へ変更
        pauseOnHover: false,
        pauseOnFocus: false,
      },

      // メディアクエリ設定（初期：751px以上の場合、スライダーを動作させない）
      mediaQuery: 'max',
      breakpoints: {
        780: {
          destroy: true,
        },
      },
    });

    // スライダーを実行
    indexAboutSliderRise.mount(window.splide.Extensions);

  }

  if ( document.querySelector('.index-about_slider_fall') !== null ) {
    let indexAboutSliderFall = new Splide('.index-about_slider_fall', {
      perPage       : 3,      // 1ページの表示数
      perMove       : 1,      // 1度にスライドを何枚移動するか
      type          : 'loop', // ループする場合
      pauseOnHover  : false,  // マウスホバー時に自動再生をストップさせない
      resetProgress : false,  // 自動再生ストップ時、経過時間を破棄せず続行する
      updateOnMove  : true,   // is-activeクラスを移動前に更新する
      gap           : '30px', // スライド間の余白（cssと同様）
      easing        : 'cubic-bezier(0.25, 1, 0.5, 1)', // 移動アニメーション
      autoHeight    : true,
      direction     : 'ttb',
      heightRatio   : .5,
      drag          : false,

      // 動き続けるスライダーを実装（拡張機能：splide-extension-auto-scroll.js）
      autoScroll: {
        speed: -.5, // 負の値で流れる向きが右へ変更
        pauseOnHover: false,
        pauseOnFocus: false,
      },

      // メディアクエリ設定（初期：751px以上の場合、スライダーを動作させない）
      mediaQuery: 'max',
      breakpoints: {
        780: {
          destroy: true,
        },
      },
    });

    // スライダーを実行
    indexAboutSliderFall.mount(window.splide.Extensions);

  }

  if ( document.querySelector('.index-about_slider_sp') !== null ) {
    let indexAboutSliderSp = new Splide('.index-about_slider_sp', {
      perPage       : 3,      // 1ページの表示数
      perMove       : 1,      // 1度にスライドを何枚移動するか
      type          : 'loop', // ループする場合
      pauseOnHover  : false,  // マウスホバー時に自動再生をストップさせない
      resetProgress : false,  // 自動再生ストップ時、経過時間を破棄せず続行する
      updateOnMove  : true,   // is-activeクラスを移動前に更新する
      gap           : 'calc(12 / 390 * 100vw)', // スライド間の余白（cssと同様）
      padding       : 'calc(52 / 390 * 100vw)', // 左右の見切れる幅（cssと同様）
      easing        : 'cubic-bezier(0.25, 1, 0.5, 1)', // 移動アニメーション
      drag          : false,
      autoWidth     : true,

      // 動き続けるスライダーを実装（拡張機能：splide-extension-auto-scroll.js）
      autoScroll: {
        speed: .5, // 負の値で流れる向きが右へ変更
        pauseOnHover: false,
        pauseOnFocus: false,
      },

      mediaQuery: 'min',
      breakpoints: {
        781: {
          destroy: true,
        },
      },

    });

    // スライダーを実行
    indexAboutSliderSp.mount(window.splide.Extensions);

  }

  if ( document.querySelector('.js-sampleOrder-slider01') !== null ) {
    let jsSampleOrderSlider01 = new Splide('.js-sampleOrder-slider01', {
      perPage       : 1,      // 1ページの表示数
      perMove       : 1,      // 1度にスライドを何枚移動するか
      speed         : 800,    // 移動時間（ミリ秒単位）
      type          : 'loop', // ループする場合
      interval      : 4000,   // 自動再生の間隔（ミリ秒単位）
      pauseOnHover  : false,  // マウスホバー時に自動再生をストップさせない
      resetProgress : false,  // 自動再生ストップ時、経過時間を破棄せず続行する
      updateOnMove  : true,   // is-activeクラスを移動前に更新する
      gap           : '30px', // スライド間の余白（cssと同様）
      padding       : '0', // 左右の見切れる幅（cssと同様）
      easing        : 'cubic-bezier(0.25, 1, 0.5, 1)', // 移動アニメーション
      focus         : 'center',

      // インビュー時から自動再生をスタート（拡張機能：splide-extension-intersection.js）
      autoplay: 'pause',

    });

    // スライダーを実行
    jsSampleOrderSlider01.mount();
  }



  if ( document.querySelector('.topics-pickup_slider') !== null ) {
    let topicsPickupSlider = new Splide('.topics-pickup_slider', {
      perPage       : 1,      // 1ページの表示数
      perMove       : 1,      // 1度にスライドを何枚移動するか
      type          : 'fade', // ループする場合
      rewind        : true,
      interval      : 6000,   // 自動再生の間隔（ミリ秒単位）
      pauseOnHover  : false,  // マウスホバー時に自動再生をストップさせない
      resetProgress : false,  // 自動再生ストップ時、経過時間を破棄せず続行する
      updateOnMove  : true,   // is-activeクラスを移動前に更新する
      gap           : '30px', // スライド間の余白（cssと同様）
      easing        : 'cubic-bezier(0.25, 1, 0.5, 1)', // 移動アニメーション
      focus         : 'center',
      autoHeight    : true,
      autoplay      : true,

      // メディアクエリ設定（初期：751px以上の場合、スライダーを動作させない）
      // mediaQuery: 'min',
      // breakpoints: {
      //   751: {
      //     destroy: true,
      //   },
      // },
    });

    // スライダーに過不足がある場合にスライダーUIを停止・排除する
    topicsPickupSlider.on('overflow', function ( isOverflow ) {
      topicsPickupSlider.go(0);
      topicsPickupSlider.options = {
        arrows    : isOverflow,
        pagination: isOverflow,
        drag      : isOverflow,
        clones    : isOverflow ? undefined : 0,
      };
    } );

    // スライダーを実行
    topicsPickupSlider.mount();
    // topicsPickupSlider.mount(window.splide.Extensions);

  }



  /**
   * Lottie Animation
   *
   */
  // トップページ：MV：HOT KEYWORDS
  const indexMvKeywordHeadIconAnim = lottie.loadAnimation({
    container: document.querySelector(".index-mv_keyword_head_icon"),
    path: '/_/media/page/index/keyword.json',
  });
  indexMvKeywordHeadIconAnim.play();

  // トップページ：MV：HOT KEYWORDS
  const topicsPickupBgContentAnim = lottie.loadAnimation({
    container: document.querySelector(".topics-pickup_bg_content"),
    path: '/_/media/page/topics/pickup-bg.json',
  });
  topicsPickupBgContentAnim.play();


  /**
   * スクロールアニメ
   *
   */
  if ( !document.querySelector('.notAnim') ) {
    // GSAPとScrollTriggerを有効化
    gsap.registerPlugin(ScrollTrigger);

    // .anim-slideUp の中身を .anim-slideUp_item でラップ
    document.querySelectorAll(".anim-slideUp").forEach((box) => {
      const wrapper = document.createElement("div");
      wrapper.classList.add("anim-slideUp_item");

      while (box.firstChild) {
        wrapper.appendChild(box.firstChild);
      }

      box.appendChild(wrapper);
    });

    // アニメーション処理
    const boxes = document.querySelectorAll(".anim-slideUp");

    // 各親要素にアニメーションを適用
    boxes.forEach((box) => {
      const items = box.querySelectorAll(".anim-slideUp_item");

      // 子要素の初期位置を設定（下に100%移動）
      gsap.set(items, { y: "100%" });

      // スクロールトリガーを設定
      ScrollTrigger.create({
        trigger: box, // トリガーは親要素
        start: "bottom 90%", // 親要素が画面中央に入った時
        onEnter: () => {
          // 子要素に順次アニメーションを適用
          items.forEach((item, index) => {
            gsap.to(item, {
              y: "0%", // 通常の位置に移動
              duration: 1, // アニメーション時間
              ease: "power3.out",
              delay: index * 0.2, // 順次アニメーションのための遅延
            });
          });
        },
      });
    });
  }


  // 初期状態で非表示にする

  if ( document.querySelector('.sampleOrderBtn') ) {
    gsap.to('.sampleOrderBtn', {
      scrollTrigger: {
        trigger: '#sampleOrderContent',
        start: 'top center',
        endTrigger: '#formtop',
        end: 'top bottom',
        toggleActions: 'play reverse play reverse',
        // markers: true,
        onEnter: () => {
          // スクロール位置が#formtopより上にある場合のみ表示
          if (!isTopVisible()) {
            gsap.to('.sampleOrderBtn', { autoAlpha: 1, duration: 0.3 });
          }
        },
        onEnterBack: () => {
          // スクロール位置が#formtopより上にある場合のみ表示
          if (!isTopVisible()) {
            gsap.to('.sampleOrderBtn', { autoAlpha: 1, duration: 0.3 });
          }
        },
        onLeave: () => {
          gsap.to('.sampleOrderBtn', { autoAlpha: 0, duration: 0.3 });
        },
        onLeaveBack: () => {
          gsap.to('.sampleOrderBtn', { autoAlpha: 0, duration: 0.3 });
        }
      }
    });
  }

// #formtopが画面内に見えているかチェックする関数
function isTopVisible() {
  const topElement = document.querySelector('#formtop');
  if (!topElement) return false;

  const rect = topElement.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom >= 0;
}



  /**
   * before after 切り替え
   *
   */
  $('.js-casecontent').hide();
  $('.js-casecontent[data-casecontent="1"]').show();

  // ボタンをクリックしたときの処理
  $('.js-casebtn').on('click', function () {
    // data-casebtn属性の値を取得
    const caseId = $(this).data('casebtn');

    // 全ての事例を非表示にして、指定された事例を表示
    $('.js-casecontent').hide();
    $(`.js-casecontent[data-casecontent="${caseId}"]`).fadeIn();

    // ボタンのスタイルを更新
    $('.js-casebtn').removeClass('is-active');
    $(this).addClass('is-active');
  });


  /**
   * よくあるご質問アコーディオン
   *
   */
  $('.m-qa_question').on('click', function() {
    $(this).next('.m-qa_answer').slideToggle();
    $(this).find('.m-qa_question_acco').toggleClass('is-open');
  });



  /**
   * メールフォームプロの入力画面／確認画面を判別する
   *
   */

  $('.mfp_element_submit').on('click', function() {
    $('.l-opening').remove();
    $('.m-bg').after('<div class="l-opening"></div>');
  });
  // ターゲット要素
  if ( $('#mfp_phase_confirm_inner').length  > 0 ) {
    const target = $('#mfp_phase_confirm_inner')[0];

    // MutationObserverの設定
    const observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                if ($('#mfp_phase_confirm_inner').children().length > 0) {
                  // 確認画面の場合の処理
                  $('.form-phase-input').hide();
                  $('.form-phase-confirm').show();
                  $('#formtop').addClass('pt:0');

                  setTimeout(function() {
                      $(window).scrollTop(0);
                  }, 100); // 500ミリ秒後
                }
            }
        });
    });

    // Observerの監視開始
    observer.observe(target, {
        childList: true, // 子ノードの追加・削除を監視
        subtree: false  // 子孫ノードは監視しない
    });

    // 監視停止する場合は以下を使用
    // observer.disconnect();
  }

  function mfpClearCookie() {
    var pathsToTry = [
      '/sample-order/',
      '/contact/'
    ];

    for (var i = 0; i < pathsToTry.length; i++) {
      document.cookie = '_MFP=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=' + pathsToTry[i] + ';';
    }
  }


  if ( !document.querySelector('.formInput') ) {
    mfpClearCookie();
  }


});

document.addEventListener('DOMContentLoaded', function() {

  if ( document.querySelector('.topics-search_form') ) {
    const form = document.querySelector('.topics-search_form');
    const checkboxes = document.querySelectorAll('.search-term');
    const clearButton = document.querySelector('.topics-search_content_btn_clear');
    const allCheckbox = document.getElementById('all');

    // フォーム送信時の処理
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (allCheckbox.checked) {
        window.location.href = '/topics/';
        return;
      }

      const selectedTerms = Array.from(checkboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.value)
        .join(',');

      if (selectedTerms) {
        window.location.href = '/topics-category/' + selectedTerms + '/';
      }
    });

    // クリアボタンの処理
    clearButton.addEventListener('click', function(e) {
      e.preventDefault();
      checkboxes.forEach(cb => cb.checked = false);
      allCheckbox.checked = true;
    });

    // 「すべて表示」の処理
    allCheckbox.addEventListener('change', function() {
      if (this.checked) {
        checkboxes.forEach(cb => cb.checked = false);
      }
    });

    // 個別のチェックボックスの変更時の処理
    checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      if (this.checked) {
        allCheckbox.checked = false;
      } else if (!Array.from(checkboxes).some(cb => cb.checked)) {
        allCheckbox.checked = true;
      }
    });
  });
  }
});

if ($('.m-scrollX_container').length > 0) {
    const $container = $('.m-scrollX_container');
    const $scrollbar = $('.custom-scrollbar');
    const $thumb = $('.scroll-thumb');

    let containerWidth, viewportWidth, thumbMaxX, contentMaxScrollX;

    // 再計算関数
    const recalculateDimensions = () => {
        containerWidth = $container[0].scrollWidth;
        viewportWidth = $container.width();
        thumbMaxX = $scrollbar.width() - $thumb.width();
        contentMaxScrollX = containerWidth - viewportWidth;

        // スクロールバーの表示/非表示を切り替え
        if (containerWidth <= viewportWidth) {
            $scrollbar.css('display', 'none');
        } else {
            $scrollbar.css('display', 'block');
        }

        // 現在のスクロール位置に合わせてスクロールバーを更新
        const currentScrollRatio = $container.scrollLeft() / contentMaxScrollX || 0;
        const currentThumbX = currentScrollRatio * thumbMaxX;
        $thumb.css('left', `${currentThumbX}px`);
    };

    // 初回計算
    recalculateDimensions();

    // ウィンドウリサイズ時に再計算
    $(window).on('resize', recalculateDimensions);

    // ドラッグ/スワイプ状態の管理
    let isDragging = false;
    let startX = 0;
    let scrollStartX = 0;

    // マウスダウン/タッチスタート
    const startDrag = (pageX) => {
        isDragging = true;
        startX = pageX;
        scrollStartX = parseInt($thumb.css('left'), 10);
        $thumb.css('cursor', 'grabbing');
    };

    $thumb.on('mousedown', function (e) {
        startDrag(e.pageX);
        e.preventDefault();
    });

    $thumb.on('touchstart', function (e) {
        const touch = e.originalEvent.touches[0];
        startDrag(touch.pageX);
        e.preventDefault();
    });

    // マウスムーブ/タッチムーブ
    const drag = (pageX) => {
        if (!isDragging) return;

        const dx = pageX - startX;
        let newLeft = scrollStartX + dx;

        // 範囲内に制限
        if (newLeft < 0) newLeft = 0;
        if (newLeft > thumbMaxX) newLeft = thumbMaxX;

        // スクロールバーの移動
        $thumb.css('left', `${newLeft}px`);

        // コンテンツのスクロール
        const scrollRatio = newLeft / thumbMaxX;
        const contentScrollX = scrollRatio * contentMaxScrollX;
        $container.scrollLeft(contentScrollX);
    };

    $(document).on('mousemove', function (e) {
        drag(e.pageX);
    });

    $(document).on('touchmove', function (e) {
        if (!isDragging) return;
        const touch = e.originalEvent.touches[0];
        drag(touch.pageX);
        e.preventDefault();
    });

    // マウスアップ/タッチエンド
    const endDrag = () => {
        isDragging = false;
        $thumb.css('cursor', 'grab');
    };

    $(document).on('mouseup', endDrag);
    $(document).on('touchend', endDrag);
}

